module.exports = "<div class=\"bottom-bar\"> \n    <div class=\"LB--logo\"></div>\n</div>"